export default function () {
	return '';
}
